<template>
    <div class="footer-box">
        <v-divider></v-divider>
        <div class="footer-top mt-4">
            <img src="../assets/images/for-the-record.png" alt="">
            <p class="ml-1">京公网安备11010802020877号</p>
            <p class="ml-2" @click="goBeiAn">京ICP备12041916号-4</p>
        </div>
        <div class="footer-mid">
            <span>©2012 - {{ y }} 北京智启蓝墨信息技术有限公司</span>
        </div>
        <div class="footer-bt">
            <div>地址：北京市海淀区上地东路 35 号颐泉汇写字楼 316 室&nbsp;&nbsp;&nbsp;&nbsp;联系电话：400-008-1078</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MFooter',
    data: function() {
        return {
            y: (new Date()).getFullYear(),
        }
    },
    methods: {
        goBeiAn: function () {
            window.open('https://beian.miit.gov.cn/#/Integrated/index', '_blank');
        }
    }
}
</script>
<style scoped>
.footer-box {
    position: relative;
    bottom: 0;
    padding: 12px 0 6px;
    color: #444;
}
.footer-top {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: inherit;
}
.footer-top img {
    width: 20px;
    height: 20px;
}
.footer-top p {
    margin-bottom: 0;
}
.footer-top p:nth-child(3) {
    cursor: pointer;
}
.footer-mid,.footer-bt {
    margin: 0 auto;
    width: 400px;
    text-align: center;
    font-size: 12px;
    color: #444;
    line-height: 24px;
}
.footer-bt {
    width: 700px;
}
</style>